import React, { useContext, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import { TranslateFunc } from '@prisjakt/ui-translate/src/translate-func';
import { ButtonType } from '@prisjakt/ui/button';
import { ProductCondition } from '../../../../types';
import { trackPriceListFilterUpdate } from '../tracking';
import { PriceListFilterContext } from '../../price-list-filter-context';
import RouteContext from '../../../../routes/context';
import { getConditions } from './utils';
import { IProductCondition, IProductConditionsProps } from './types';
import { setSelectedCondition } from '../../actions/product';
import * as S from './styles';

const ProductConditions: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IProductConditionsProps>
>> = props => {
  const { selectedFilters, selectedCondition } = useContext(
    PriceListFilterContext
  );

  const dispatch = useDispatch();
  const { dispatch: routeDispatch } = useContext(RouteContext);
  const { t } = useContext(AppContext);
  const instanceId = useRef(Math.random()); // Since this is used inside media queries, we get aria failiures on non-unique keys without this

  const handleSelectedCondition = (cond: IProductCondition) => {
    // Prevent request if already selected condition is clicked again
    if (cond.name === selectedCondition) return null;

    dispatch(setSelectedCondition(cond.name));
    trackPriceListFilterUpdate(cond.name, false);

    return routeDispatch({
      type: 'PRODUCT_CONDITION',
      options: selectedFilters,
      condition: cond.name,
    });
  };

  const conditions = getConditions(props.priceListStatistics);

  return (
    <div>
      <S.VariantGroup>
        {conditions.map(condition => {
          const key = `${condition.name}-${instanceId.current}`;
          const name = `${getConditionName(condition.name, t)} (${
            condition.count
          })`;

          return (
            <S.SelectableButton
              key={key}
              onClick={() => handleSelectedCondition(condition)}
              selected={condition.name === selectedCondition}
              ariaLabel={name}
              type={ButtonType.TONAL}
            >
              {name}
            </S.SelectableButton>
          );
        })}
      </S.VariantGroup>
    </div>
  );
};

const getConditionName = (type: ProductCondition, t: TranslateFunc): string => {
  switch (type) {
    case 'used':
      return t('product', 'price-filter.used-short');
    case 'new':
    default:
      return t('product', 'price-filter.new');
  }
};

export default ProductConditions;
